import PhotoSwipe from 'photoswipe';
import PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default.js';
import Swiper from 'swiper/dist/js/swiper.js';
import $ from 'jquery';
import { MediaQuery, Magellan, SmoothScroll, Tabs } from 'foundation-sites';
import Headroom from 'headroom.js';
import scrollMonitor from 'scrollmonitor';

var gallery;
var galleryIndex;
var productImages;

var initPhotoSwipeFromDOM = function (gallerySelector) {

  // parse slide data (url, title, size ...) from DOM elements
  // (children of gallerySelector)
  var parseThumbnailElements = function (el) {
    var thumbElements = el.childNodes,
      numNodes = thumbElements.length,
      items = [],
      figureEl,
      linkEl,
      size,
      item;

    for (var i = 0; i < numNodes; i++) {

      figureEl = thumbElements[i]; // <figure> element

      // include only element nodes
      if (figureEl.nodeType !== 1) {
        continue;
      }

      linkEl = figureEl.children[0]; // <a> element

      size = linkEl.getAttribute('data-size').split('x');

      // create slide object
      item = {
        src: linkEl.getAttribute('href'),
        w: parseInt(size[0], 10),
        h: parseInt(size[1], 10)
      };

      if (figureEl.children.length > 1) {
        // <figcaption> content
        item.title = figureEl.children[1].innerHTML;
      }

      if (linkEl.children.length > 0) {
        // <img> thumbnail element, retrieving thumbnail url
        item.msrc = linkEl.children[0].getAttribute('src');
      }

      item.el = figureEl; // save link to element for getThumbBoundsFn
      items.push(item);
    }

    return items;
  };

  // find nearest parent element
  var closest = function closest(el, fn) {
    return el && (fn(el) ? el : closest(el.parentNode, fn));
  };

  // triggers when user clicks on thumbnail
  var onThumbnailsClick = function (e) {
    e = e || window.event;
    e.preventDefault ? e.preventDefault() : e.returnValue = false;

    var eTarget = e.target || e.srcElement;

    // find root element of slide
    var clickedListItem = closest(eTarget, function (el) {
      return (el.tagName && el.tagName.toUpperCase() === 'FIGURE');
    });

    if (!clickedListItem) {
      return;
    }

    // find index of clicked item by looping through all child nodes
    // alternatively, you may define index via data- attribute
    var clickedGallery = clickedListItem.parentNode,
      childNodes = clickedListItem.parentNode.childNodes,
      numChildNodes = childNodes.length,
      nodeIndex = 0,
      index;

    for (var i = 0; i < numChildNodes; i++) {
      if (childNodes[i].nodeType !== 1) {
        continue;
      }

      if (childNodes[i] === clickedListItem) {
        index = nodeIndex;
        break;
      }
      nodeIndex++;
    }

    if (index >= 0) {
      // open PhotoSwipe if valid index found
      openPhotoSwipe(index, clickedGallery);

      gallery.listen('beforeChange', function () {
        galleryIndex = gallery.getCurrentIndex();
        productImages.slideTo(galleryIndex);
      });
    }
    return false;
  };


  // parse picture index and gallery index from URL (#&pid=1&gid=2)
  var photoswipeParseHash = function () {
    var hash = window.location.hash.substring(1),
      params = {};

    if (hash.length < 5) {
      return params;
    }

    var vars = hash.split('&');
    for (var i = 0; i < vars.length; i++) {
      if (!vars[i]) {
        continue;
      }
      var pair = vars[i].split('=');
      if (pair.length < 2) {
        continue;
      }
      params[pair[0]] = pair[1];
    }

    if (params.gid) {
      params.gid = parseInt(params.gid, 10);
    }

    return params;
  };

  var openPhotoSwipe = function (index, galleryElement, disableAnimation, fromURL) {
    var pswpElement = document.querySelectorAll('.pswp')[0],
      options,
      items;

    items = parseThumbnailElements(galleryElement);

    // define options (if needed)
    options = {
      closeOnScroll: false,
      shareEl: false,

      // define gallery index (for URL)
      galleryUID: galleryElement.getAttribute('data-pswp-uid'),

      getThumbBoundsFn: function (index) {
        // See Options -> getThumbBoundsFn section of documentation for more info
        var thumbnail = items[index].el.getElementsByTagName('img')[0], // find thumbnail
          pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
          rect = thumbnail.getBoundingClientRect();

        return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
      }

    };

    // PhotoSwipe opened from URL
    if (fromURL) {
      if (options.galleryPIDs) {
        // parse real index when custom PIDs are used
        // http://photoswipe.com/documentation/faq.html#custom-pid-in-url
        for (var j = 0; j < items.length; j++) {
          if (items[j].pid == index) {
            options.index = j;
            break;
          }
        }
      } else {
        // in URL indexes start from 1
        options.index = parseInt(index, 10) - 1;
      }
    } else {
      options.index = parseInt(index, 10);
    }

    // exit if index not found
    if (isNaN(options.index)) {
      return;
    }

    if (disableAnimation) {
      options.showAnimationDuration = 0;
    }

    // Pass data to PhotoSwipe and initialize it
    gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
    gallery.init();

    window.gallery = gallery;
  };

  // loop through all gallery elements and bind events
  var galleryElements = document.querySelectorAll(gallerySelector);

  for (var i = 0, l = galleryElements.length; i < l; i++) {
    galleryElements[i].setAttribute('data-pswp-uid', i + 1);
    galleryElements[i].onclick = onThumbnailsClick;
  }

  // Parse URL and open gallery if it contains #&pid=3&gid=1
  var hashData = photoswipeParseHash();
  if (hashData.pid && hashData.gid) {
    openPhotoSwipe(hashData.pid, galleryElements[hashData.gid - 1], true, true);
  }
};

// Product page slider image (product color variant)
const productImagesContainer = document.querySelector('.js-product-images');

// When the document has loaded all the assets
window.addEventListener('load', function() {

  // execute above function
  initPhotoSwipeFromDOM('.js-photoswipe');

  if (productImagesContainer) {
    const productImagesCount = productImagesContainer.querySelectorAll('.swiper-slide');


    if (productImagesCount.length > 1) {
      const productColors = productImagesContainer.querySelectorAll('.js-product-colors');
      const colorLabelContainer = productImagesContainer.querySelector('.product__current-colors');

      let colorTop;
      let colorBottom;
      let colorLabel;

      productImages = new Swiper(productImagesContainer, {
        slidesPerView: 1,
        keyboard: {
          enabled: true,
        },
        pagination: {
          el: productImagesContainer.querySelector('.swiper-pagination'),
          clickable: true,
          renderBullet: function(index, className) {
            colorTop = productColors[index].getAttribute('data-color-top');
            colorBottom = productColors[index].getAttribute('data-color-bottom');

            if (colorTop && colorBottom) {
              return `<div class="product__colors ${className}" data-color-label="${productColors[index].innerHTML}">
                        <div class="product__colors__half" style="background-color: ${colorTop};"></div>
                        <div class="product__colors__half" style="background-color: ${colorBottom};"></div>
                      </div>`;
            } else {
              return `<div class="product__colors ${className}" data-color-label="${productColors[index].innerHTML}">
                        <div class="product__colors__half" style="background-color: ${colorTop};"></div>
                      </div>`;
            }
          }
        }
      });

      colorLabel = productImagesContainer.querySelector('.swiper-pagination-bullet-active').getAttribute('data-color-label');
      colorLabelContainer.innerHTML = colorLabel;

      productImages.on('slideChange', function () {
        colorLabel = productImagesContainer.querySelector('.swiper-pagination-bullet-active').getAttribute('data-color-label');
        colorLabelContainer.innerHTML = colorLabel;
      });
    }

  }

  // Foundation Tabs init
  const tabs = $('.js-tabs');
  if (tabs.length) {
    const tabsEl = new Tabs(tabs);
  }

  //Headroom sticky nav
  MediaQuery._init();
  const stickyNav = document.querySelector('.js-sticky-nav');

  if (stickyNav) {
    const stickyAnchor = window.innerHeight;
    const stickyOffset = stickyAnchor - 300; // 240px is the value of the main nav + the sticky height + a small margin
    // construct an instance of Headroom, passing the element
    var headroom = new Headroom(stickyNav, {
      // vertical offset in px before element is first unpinned
      offset : stickyOffset,
      // scroll tolerance in px before state changes
      tolerance : 5,
      // css classes to apply
      classes : {
        // when element is initialised
        initial : "sticky-nav--active",
        // when scrolling up
        pinned : "sticky-nav--unpinned",
        // when scrolling down
        unpinned : "sticky-nav--pinned",
        // when above offset
        top : "sticky-nav--top",
        // when below offset
        notTop : "sticky-nav--not-top",
        // when at bottom of scoll area
        bottom : "",
        // when not at bottom of scroll area
        notBottom : ""
      }
    });

    // initialise
    if (MediaQuery.atLeast('large')) {
      headroom.init();
    }

    $(window).on('changed.zf.mediaquery', function(event, newSize, oldSize) {
      if (newSize === 'medium' || newSize === 'small') {
        headroom.destroy();
      }
      if ((oldSize === 'medium' || oldSize === 'small') && newSize === 'large') {
        headroom.init();
      }
    });
  }

  // scrollMonitor to watch when element is in viewport
  const watchMe = document.querySelector('.js-watch');

  if (watchMe) {
    const elementWatcher = scrollMonitor.create( watchMe );
    const gauge = document.querySelectorAll('.js-gauge-progress');

    // Animate the gauge when fully entering the viewport
    elementWatcher.fullyEnterViewport(function() {
      if (gauge) {
        gauge.forEach((gaugeEl) => {
          const gaugeProgress = gaugeEl.getAttribute('data-progress');
          const gaugeLength = 2 * Math.PI * 80;
          const gaugeDashOffset = gaugeLength * (1 - (gaugeProgress / 100 ));
          const gaugeFill = gaugeEl.querySelector('.js-gauge-toggle');

          gaugeFill.style.strokeDashoffset = gaugeDashOffset;
        });
      }
    });
  }

  // start SmoothScroll if the menu is here
  const smoothScrollMenu = $('.js-smooth-scroll');

  if (smoothScrollMenu.length) {
    const smoothScrollEls = new SmoothScroll(smoothScrollMenu);
  }


});

// Foundation Magellan on Navigation
// Init Magellan OUTSIDE the DOM Load event
// If not, the scroll event isn't fired
const spyingNav = $('.js-spying-nav');
if (spyingNav.length) {
  const spyingNavEl = new Magellan(spyingNav);
}





